import React from 'react'
import BootstrapTable from 'react-bootstrap-table-next'
import ToolkitProvider from 'react-bootstrap-table2-toolkit'
import {Pagination} from "./Pagination";
import {NoDataIndication} from "./NoDataIndication";
import {DataGridProps} from "./types";
import overlayFactory from 'react-bootstrap-table2-overlay';

export const DataGrid = ({
  data,
  columns,
  keyField,
  sizePerPage,
  page,
  count,
  onTableChange,
  expandRow,
  rowStyle,
  headerWrapperClasses,
  name,
  hiddenRows,
  showOnlyPages,
}:DataGridProps) => {
  return (
    <ToolkitProvider
      keyField={keyField ? keyField : 'url'}
      data={data}
      columns={columns}
    >
      {(props) => (
        <BootstrapTable
          name={name}
          {...props}
          remote
          striped
          hover
          condensed
          noDataIndication={ () => <NoDataIndication />}
          hiddenRows={hiddenRows}
          rowStyle={rowStyle}
          headerWrapperClasses={headerWrapperClasses}
          pagination={Pagination(page, sizePerPage, count, showOnlyPages)}
          bordered={false}
          onTableChange={onTableChange}
          expandRow={expandRow}
          {...props.baseProps}
          overlay={ overlayFactory({ spinner: true, background: 'rgba(192,192,192,0.3)' }) }
        />
      )}
    </ToolkitProvider>
  )
}
